export default {
    label: 'How would you like to arrange your service appointment',
    labelSelfService: 'Thank you for the information',
    text: 'We’ll be happy to arrange an appointment for you — or have you already booked one yourself?',
    textSelfService: 'You can now close this window.',
    buttonOrderService: 'Order service',
    buttonSelfService: 'I have already booked'
}
